const actions = {
	LOAD_RESULTS: "LOAD_RESULTS",
	FETCH: 'FETCH'
}

export default actions